import { ValidationSchema } from '../../../../../@types/validation-types'
import {
  defaultApiSearchData,
  defaultConnections,
  defaultConstruction,
  defaultDescription,
  defaultHangarBasicInfo,
  defaultHangarOtherFacilities,
  defaultObjectNumbers,
  useManualAndInternationalAddress,
  usePurchasePriceOnRequestCondition,
} from '../../../../../services/validation/flow/defaultSchemas'
import { validationRules } from '../../../../../services/validation/rules/validationRules'

export const agentProductionHallSellSchema: ValidationSchema = {
  address: useManualAndInternationalAddress,
  basicInfo: {
    ...defaultHangarBasicInfo,
    price: usePurchasePriceOnRequestCondition,
    courtage: validationRules.courtage,
    courtageNote: validationRules.courtageNote,
  },
  description: { ...defaultDescription, adFurnishingNote: validationRules.adFurnishingNote },
  construction: defaultConstruction,
  otherFacilities: defaultHangarOtherFacilities,
  connections: defaultConnections,
  objectNumbers: defaultObjectNumbers,
  apiSearchData: defaultApiSearchData,
}
